import {createPaginatedSlice} from '../createPaginatedSlice';
import {loadEmployees} from '../../services/employee.servcice';
import {Employee} from '../../models/employee.model';

const employeesSlice = createPaginatedSlice<Employee>({
    name: 'employees',
    fetchFn: loadEmployees,
    defaultSortBy: 'id',
});

export const employeesActions = employeesSlice.actions;
export const employeesReducer = employeesSlice.reducer;
